<template>
  <div v-if="visible" class="novedades">
    <div class="novedades-cabecera">
      <span class="novedades-icono"><v-icon color="#e3b08a">mdi-star-four-points-outline</v-icon></span>
      <div class="novedades-titulos">
        <div class="novedades-titulo">{{ titulo }}</div>
        <div class="novedades-sub">{{ subtitulo }}</div>
      </div>
      <v-btn icon small @click="cerrar" title="Cerrar"><v-icon small color="#8a8a8a">mdi-close</v-icon></v-btn>
    </div>
    <ul class="novedades-lista">
      <li v-for="(n, i) in novedades" :key="i">
        <span class="tag">{{ n.tag }}</span>
        <span>{{ n.texto }}</span>
      </li>
    </ul>
    <div class="novedades-pie">
      <span class="version">Versión {{ version }}</span>
      <v-btn depressed small color="#BA6B30" class="white--text" @click="cerrar">Entendido</v-btn>
    </div>
  </div>
</template>

<script>
import { novedadesRecientes, versionActual } from "@/changelog";

// Aviso de novedades de la última versión, una sola vez por dispositivo:
// al cerrarlo se guarda la versión vista. Cada contexto muestra lo suyo
// (el cajero no necesita enterarse de los reportes).
const CLAVE = "novedades_vistas";

export default {
  name: "NovedadesBanner",
  props: {
    contexto: { type: String, default: "todos" }, // 'pos' | 'todos'
    titulo: { type: String, default: "Cambiamos algunas pantallas" },
    subtitulo: { type: String, default: "Tardan un minuto en entenderse. Esto es lo que vas a notar:" },
  },
  data() {
    return { visible: false };
  },
  computed: {
    version() {
      return versionActual();
    },
    novedades() {
      return novedadesRecientes(this.contexto);
    },
  },
  created() {
    if (!this.novedades.length) return;
    try {
      this.visible = localStorage.getItem(CLAVE) !== this.version;
    } catch (e) {
      this.visible = true;
    }
  },
  methods: {
    cerrar() {
      this.visible = false;
      try {
        localStorage.setItem(CLAVE, this.version);
      } catch (e) {
        /* sin storage se vuelve a mostrar, no es grave */
      }
    },
  },
};
</script>

<style scoped>
.novedades {
  background: linear-gradient(135deg, rgba(186, 107, 48, 0.14), rgba(186, 107, 48, 0.04));
  border: 1px solid rgba(186, 107, 48, 0.45);
  border-radius: 16px;
  padding: 16px 18px 14px;
  margin-bottom: 18px;
}
.novedades-cabecera {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.novedades-icono {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(186, 107, 48, 0.2);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.novedades-titulos {
  flex: 1;
}
.novedades-titulo {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
}
.novedades-sub {
  font-size: 13px;
  color: #b5b5b5;
}
.novedades-lista {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.novedades-lista li {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  color: #e6e6e6;
  font-size: 14px;
  line-height: 1.4;
}
.tag {
  flex-shrink: 0;
  font-size: 10px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #e3b08a;
  border: 1px solid rgba(227, 176, 138, 0.5);
  border-radius: 999px;
  padding: 2px 8px;
  margin-top: 2px;
}
.novedades-pie {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 14px;
}
.version {
  font-size: 12px;
  color: #8a8a8a;
}
</style>
